// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"112":"08aa377d","528":"81267f05","823":"1d23a050"}[chunkId] + ".chunk.css";
};